import React, {useState, Component} from 'react';
import * as firebase from 'firebase'
import { Redirect, Route } from 'react-router'
import Header from './Header.js';
import Footer from './Footer.js';

import {
    Badge,
    Card,
    CardBody,
    CardHeader,
    CardTitle,
    Table,
    CardImg,
    FormGroup,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Modal,
    UncontrolledTooltip
  
  } from "reactstrap";

export default class ApplicationDetails extends Component {
  // const [weightText, setWeightText] = useState("")
constructor(props){
   super(props);
   this.state={
    name: '',
    gender: '',
    age: '',
    state: '',
    appID: '',
    mobileNumber: '',
    bankName: '',
    acntNum: '',
    acntName: '',
    amountApproved: '',
    regDate: '',
    eduLevel: '',
    loaded: false
   }
} 


loadUserData(){

let mobileNum =    localStorage.getItem('mobileNumberDetails')

    const dbRefObject = firebase.database().ref().child('users');
      dbRefObject.on('value', snapshot => {
        // convert messages list from snapshot
        const usersObject = snapshot.val();
  
        if (usersObject) {
          const usersList = Object.keys(usersObject).map(key => ({
            ...usersObject[key],
            uid: key,
          }));
          var user = firebase.auth().currentUser;
  
  
          usersList.map(data => {
            try {
              if (data.mobileNumber === mobileNum || data.applicationID === mobileNum) {
  
                this.setState({
                    name: data.firstName+" "+data.surName,
                    gender: data.gender,
                    age: data.age,
                    state: data.stateOfOrigin,
                    appID: data.applicationID,
                    mobileNumber: data.mobileNumber,
                    bankName: data.bankName,
                    acntNum: data.accountNumber,
                    acntName: data.accountName,
                    amountApproved: data.amountApproved,
                    regDate: data.dateRegistered,
                    eduLevel: data.educationLevel,
                    loaded: true
                })
                //console.log(data.mobileNumber)
                
              }
  
  
            }
            catch{
  
            }
          });
        } else {
          // this.setState({ users: null, });
        }
      });
  }
  
componentDidMount(){
  this.loadUserData()
}
   

render(){
  

let mobileNumber = localStorage.getItem('mobileNumberDetails')
let regDate = new Date(this.state.regDate+6963212206);
let formattedDate = regDate.toDateString()
 

  
  if (mobileNumber !== null) {
  return (
    <>
    <Header/>
  
    <div  class="container" style={{marginTop: 120}} >
    <CardBody>
    

    <h3 className="display-3 text-success" style={{fontSize: '25px', marginBottom: 20, fontWeight: 'bold'}}>Nigeria Youths' Empowerment 2021</h3>

    <table class="table table-hover table-success">
  
  <tbody>
  <tr>
      <th scope="row">NAME</th>
  <td>{this.state.name}</td>
      
    </tr>
    <tr>
      <th scope="row">GENDER</th>
      <td>{this.state.gender}</td>
      
    </tr>
    <tr>
      <th scope="row">AGE</th>
      <td>{this.state.age}</td>
      
    </tr>
    <tr>
      <th scope="row">STATE OF ORIGIN</th>
      <td colspan="2">{this.state.state}</td>
     
    </tr>
    <tr>
      <th scope="row">MOBILE NUMBER</th>
      <td colspan="2">{this.state.mobileNumber}</td>
     
    </tr>
    <tr>
      <th scope="row">EDUCATION LEVEL</th>
      <td colspan="2">{this.state.eduLevel}</td>
     
    </tr>
    <tr>
      <th scope="row">AMOUNT APPROVED</th>
      <td colspan="2">&#8358;{this.state.amountApproved}</td>
     
    </tr>
    <tr>
      <th scope="row">ACCOUNT NUMBER</th>
      <td colspan="2">{this.state.acntNum}</td>
     
    </tr>

    <tr>
      <th scope="row">BANK NAME</th>
      <td colspan="2">{this.state.bankName}</td>
     
    </tr>

    <tr>
      <th scope="row">ACCOUNT NAME</th>
      <td colspan="2">{this.state.acntName}</td>
     
    </tr>




    <tr>
      <th scope="row">APPLICATION ID</th>
      <td colspan="2">{this.state.appID}</td>
     
    </tr>

    <tr>
      <th scope="row">PAYMENT DATE</th>
      <td colspan="2">{formattedDate}</td>
     
    </tr>
  </tbody>
</table>
                    </CardBody>
                   
 </div>
      <Footer/>
      </>
    );
      }
    else return (
      <Redirect to={'/'} />
    )
  }
}

//export default ApplicationForm;
